module.exports = "/assets/data/fb6df48e4762350ed21bfd5cbed63dbd-NR11.data.json";